module["exports"] = [
  "#{street_name} #{building_number}",
  "#{street_name} #{building_number}, #{secondary_address}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/address/street_address.js
 ** module id = 759
 ** module chunks = 0
 **/